"use strict";

var _propTypes = _interopRequireDefault(require("prop-types"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

function _typeof(a) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
    return typeof a;
  } : function (a) {
    return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, _typeof(a);
}

var unsetError = function unsetError(a, b) {
  !b || b && "object" === _typeof(b) && b[a] && delete b[a];
},
    _default = unsetError;

exports["default"] = _default, unsetError.propTypes = {
  id: _propTypes["default"].number.isRequired,
  errorMessages: _propTypes["default"].func
};